import STORAGE_KEYS from "@src/constants/storageKeys";
import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

const Login = lazy(() => import("@pages/auth/Login"))
const Wildcard = lazy(() => import("@pages/Wildcard"));

const Profile = React.lazy(() => import("@pages/Profile"));
const ForgotPassword = React.lazy(() => import("@pages/auth/ForgotPassword"));
const Register = React.lazy(() => import("@pages/auth/Register"));
const ModuleSelectionTable = React.lazy(() => import("@src/components/shared/ModuleSelectionTable"));
const Dashboard = React.lazy(() => import("@src/layout/Dashboard"));
const LoginLayout = React.lazy(() => import("@src/layout/LoginLayout"));
const Admission = React.lazy(() => import("@src/pages/AdmissionsStages/Admission"));
const ApplicationTracking = React.lazy(() => import("@src/pages/Dashboard/ApplicationTracking"));
const OnlinePayment = React.lazy(() => import("@src/pages/Payment/OnlinePayment"));
const PaymentHistoryTable = React.lazy(() => import("@src/pages/PaymentHistoryTable"));
const SelectedModules = React.lazy(() => import("@src/pages/SelectedModules"));
export const isAuthenticated = () => {
  return !!localStorage.getItem(STORAGE_KEYS.auth_details);
};


export const routes = [
  {
    path: "/", element: <LoginLayout />, protected: false, children: [
      {
        index: true, // This is the default when visiting /auth
        element: <Navigate to="/auth/login" replace />
      },
      { path: "/auth/login", element: <Login />, protected: false },
      { path: "/auth/register", element: <Register />, protected: false },
      { path: "/auth/forgotpassword", element: <ForgotPassword />, protected: false },
    ]
  },
  {
    path: "/payment", element: <OnlinePayment />, protected: true
  },
  {
    path: "/dashboard",
    element: <Dashboard />, // Parent layout
    protected: true,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard/application" replace />
      },
      { path: "profile", element: <Profile />, protected: true },
      { path: "admission", element: <Admission />, protected: true, allowedRoles: [{ application: ['create'] }] },
      { path: "admission/:id", element: <Admission />, protected: true, allowedRoles: [{ application: ['create'] }] },
      { path: "application", element: <ApplicationTracking />, protected: true },
      { path: "payments", element: <PaymentHistoryTable />, protected: true },
      { path: 'moduleSelection', element: <ModuleSelectionTable />, protected: true },
      { path: 'selected-modules', element: <SelectedModules />, protected: true },

    ],
  },
  { path: "*", element: <Wildcard /> },
];